import { useContext } from 'react';

import type { FormFieldMessageContextProps } from '../contexts/FormFieldMessageContext.js';
import { FormFieldMessageContext } from '../contexts/FormFieldMessageContext.js';

export const useFormFieldMessagesContext = (): FormFieldMessageContextProps =>
  useContext(FormFieldMessageContext);
